import { HeadlessFormProvider } from '@delmonicos/shared-design-system-react/src/contexts/headless-form.provider';
import { SubmitHandlerWithDirtyFields } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { GetTariffsPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/tariffs/get-tariffs-paginated.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { useFilterSearchEmspBoTariffListContext } from '../../emsp-bo-tariff.context';
import { EmspBoTariffListFilterSearchFormStep1Controller } from '../emsp-bo-tariff-list-filter-search-form-step-1/emsp-bo-tariff-list-filter-search-form-step-1.controller';

export interface EmspBoTariffListFilterSearchFormControllerProps {
  onError: SubmitErrorHandler<GetTariffsPaginatedModel>;
  onSubmit: SubmitHandlerWithDirtyFields<GetTariffsPaginatedModel>;
  onCancel: () => void;
}

export const EmspBoTariffListFilterSearchFormController = (
  props: EmspBoTariffListFilterSearchFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel } = props;
  const data = useFilterSearchEmspBoTariffListContext();

  return (
    <HeadlessFormProvider<GetTariffsPaginatedModel>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      item={{
        fields: ['textToSearch'],
        component: <EmspBoTariffListFilterSearchFormStep1Controller />,
      }}
    />
  );
};
